import styled from "styled-components"

export const Dash2 = styled.div`
  display: flex;
  background-color: black ;
  width: 100%;
  position: sticky;
  top:0;
  right: 0;
  background-color:black ;
  z-index:1;

  
`
export const Wrapper2 = styled.div`
  display: flex;
  width: 100%;
  flex-direction:row;
  margin: 0px 100px;
  padding: 25px 0px;
  border-bottom: 0.01cm #595959 solid;

  @media screen and (max-width: 950px){
    margin: 0px 20px;
  }
`
export const Left2 = styled.div`
  flex: 1;
  display: flex;
  align-items:center;
`
export const Right2 = styled.div`
  display: flex;
  flex: 1;
  justify-content:flex-end;
  align-items:center;
`
export const LastDashIconContainer2 = styled.div`
    display: flex;
    justify-content: center;
    border-radius: 50%;
    padding: 3px;
    margin-left: 10px;
    cursor: pointer;
`
export const DashIconContainer2 = styled.div`
    display: flex;
    justify-content: center;
    border: 2px #595959 solid;
    stroke-width: 2px;
    fill: transparent;
    border-radius: 50%;
    padding: 10px;
    margin-left: 15px;
    width: 50px;
    height: 50px;
    cursor: pointer;

    &:hover{
      border-color:#40a9ff;
      color: #40a9ff;
      background-color: rgba(64,169,255,0.3125) ;
    }

    &:hover > div > svg > g > g > path {
      fill: #40a9ff;
    }
`
export const Link2 = styled.div`
  color: white;
`
export const LeftCaption2 = styled.div`
  font-size:24px;
  font-weight:400;
  color: white;
  margin-left: 15px;
`
export const DashLogo2 = styled.img`
  height: 40px;
  width: 34px;
`
export const DashIcons2 = styled.div`
  display: flex;
  flex-direction: row;
  align-items:center;

  @media screen and (max-width: 950px){
      display:none
    }
  
`
export const ProfileInfo = styled.div`
    color: #389e0d;
    line-height:15px;
    font-size:15px;
    text-align:center;
    display:flex;
    flex-direction:column;
    justify-content:center;
    height:100%;
    text-align:right;

    @media screen and (max-width: 950px){
      display:none
    }
`
export const WalletAddress = styled.div`
    color: #8c8c8c;
    font-size:16px;
    line-height: 19px;
    text-align:right;
`
export const UserIconContainer = styled.div`
    display: flex;
    justify-content: center;
    border: 2px transparent solid;
    border-radius: 50%;
    margin-left: 15px;
    width: 54px;
    height: 54px;
    cursor: pointer;

    &:hover {
      border: 2px #40a9ff solid;
    }
`
export const UserIcon = styled.img`
    width: 100%;
    height: 100%;
`
export const Icon = styled.img`
  width:24px;
  height:24px;

`